import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenStorageService } from '../services/token-storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const tokenStorageService = inject(TokenStorageService);
  const router = inject(Router);

  // Check for ?token=xxx query param (deep link)
  const tokenParam = route.queryParamMap.get('token');
  if (tokenParam) {
    tokenStorageService.storeToken(tokenParam);
    // Redirect to the requested route without query params
    const path = state.url.split('?')[0];
    const target = path && path !== '/' ? path : '/bill-pay';
    router.navigate([target]);
    return false;
  }

  // Check if already authenticated
  if (tokenStorageService.isAuthenticated()) {
    return true;
  }

  // Not authenticated — redirect to login, remembering where they were headed
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
